<section>
    <div class="row">
        <div class="col-md-12">
            <sp-property-filter
                [propertyFilterSettings]="propertyFilterSettings"
                [propertyTypes]="propertyTypes"
                [activeFilterDropdown]="dropDownValues"
                [isActiveFilterEnabled]="true"
                (filterChanged)="onFilterChanged($event)"
                (isActiveDropdownChanged)="onActiveDropdownChanged($event)">
            </sp-property-filter>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">

            <!-- Require filter(s) message -->
            <sp-no-results-found *ngIf="!hasFilterData()" [message]="'A filter is required to view properties'"></sp-no-results-found>            
            <sp-no-results-found *ngIf="hasFilterData() && propertySearchResult?.properties?.length == 0" [message]="'No properties found'"></sp-no-results-found>

            <div *ngIf="hasFilterDataAndResults()">
                <dx-data-grid
                    #dxAdminPropertiesDataGrid
                    id="adminPropertiesDataGrid"
                    [dataSource]="dataGridSource"
                    [showColumnLines]="false"
                    [showRowLines]="true"
                    [showBorders]="false"
                    (onRowPrepared)="dxGridRowPrepared($event)"  
                    (onContextMenuPreparing)="dxOnContextMenuPreparing($event)">                 
                    
                    <dxi-data-grid-column cssClass="dx-grid-cell-wrapped" dataField="name" caption="Property Name" alignment="left" cellTemplate="propertyNameTemplate" width="300">
                        <div *dxTemplate="let cellData of 'propertyNameTemplate'">
                            <div *ngIf="loggedInUserProfile?.isSmartPropertyAdmin">
                                <a [href]="'/#/useraccount/admin/portfolios/' + cellData.row.data.workspaceId + '/edit-property/' + cellData.row.data.propertyId + '?navigatedFromPropertyList=true'">
                                    {{ cellData.value }}
                                </a>    
                            </div>
                            <div *ngIf="!loggedInUserProfile?.isSmartPropertyAdmin">
                                <a [href]="'/#/useraccount/admin/properties/' + cellData.row.data.propertyId">
                                    {{ cellData.value }}
                                </a>  
                            </div>                                                                                     
                        </div>
                    </dxi-data-grid-column>
                    
                    <dxi-data-grid-column cssClass="dx-grid-cell-wrapped" caption="Portfolio" alignment="left" width="200" cellTemplate="portfolioNameTemplate">
                        <div *dxTemplate="let cellData of 'portfolioNameTemplate'">
                            <div *ngIf="loggedInUserProfile?.isSmartPropertyAdmin">
                                <a [href]="'/#/useraccount/admin/portfolios/' + cellData.row.data.workspaceId">
                                    {{ cellData.row.data.workspaceCompanyName || cellData.row.data.workspaceName }}
                                </a>    
                            </div>
                            <div *ngIf="!loggedInUserProfile?.isSmartPropertyAdmin">  
                                {{ cellData.row.data.workspaceCompanyName || cellData.row.data.workspaceName }} 
                            </div>                                                                          
                        </div>
                    </dxi-data-grid-column>
                    <dxi-data-grid-column cssClass="dx-grid-cell" dataField="propertyTypeName" caption="Property Type" alignment="left"></dxi-data-grid-column>
                    <dxi-data-grid-column cssClass="dx-grid-cell" caption="Location" alignment="left" [calculateCellValue]="dxCalculateCellValueForLocationColumn"></dxi-data-grid-column>
                    <dxi-data-grid-column cssClass="dx-grid-cell" dataField="originalCreatedOn" caption="Date Added" dataType="date" alignment="left"></dxi-data-grid-column>        
                    <dxi-data-grid-column cssClass="dx-grid-cell" dataField="isTest" [calculateCellValue]="dxCalculateCellValueForIsTestColumn" caption="Is Test?" alignment="left"></dxi-data-grid-column>

                    <dxi-data-grid-column cssClass="dx-grid-cell" dataField="isActive" caption="Status" alignment="left" cellTemplate="activeTemplate" ></dxi-data-grid-column>
                    <div *dxTemplate="let cellData of 'activeTemplate'">
                        <div *ngIf="cellData.row.data.isActive">
                            <span class="status-badge badge-active">Active</span>
                        </div>
                        <div *ngIf="!cellData.row.data.isActive">
                            <span class="status-badge badge-inactive">Inactive</span>
                        </div>
                    </div>

                    <dxi-data-grid-column cssClass="dx-grid-cell" alignment="right" cellTemplate="propertyId">
                        <div *dxTemplate="let cellData of 'propertyId'">                
                            <dx-button 
                                id="btnShowActionMenu"
                                hint="Action Menu"
                                [hoverStateEnabled]="false"
                                [activeStateEnabled]="false"
                                stylingMode="text" 
                                type="normal" 
                                icon="overflow" 
                                (onClick)="showActionMenu($event)">
                            </dx-button>                  
                        </div>
                    </dxi-data-grid-column>                    
                    
                    <dxo-data-grid-scrolling rowRenderingMode="virtual"> </dxo-data-grid-scrolling>
                    <dxo-data-grid-paging [pageSize]="10"> </dxo-data-grid-paging>
                    <dxo-data-grid-pager
                        [visible]="true"
                        [allowedPageSizes]="[10, 25, 50, 'all']"
                        [displayMode]="'compact'"
                        [showPageSizeSelector]="true"
                        [showInfo]="true"
                        [showNavigationButtons]="true">
                    </dxo-data-grid-pager>
                </dx-data-grid>
            </div>
        </div>
    </div>
</section>

<sp-modal #deactivatePropertyStatusModal title="DEACTIVATE THIS PROPERTY" (confirm)="deactivateProperty()" confirmButtonText="OK" [isWarning]="true">
    Are you sure you want to deactivate this property?  Users will not be able to access this property anymore.
</sp-modal>

<sp-modal #reactivatePropertyStatusModal title="REACTIVATE THIS PROPERTY" (confirm)="reactivateProperty()" confirmButtonText="OK" [isWarning]="true">
    Are you sure you want to reactivate this property?
</sp-modal>

<sp-admin-reassign-property-modal
    #reassignPropertyModal    
    (onConfirm)="onReassignPropertyConfirm($event)">
</sp-admin-reassign-property-modal>

<sp-modal #duplicatePropertyModal title="DUPLICATE THIS PROPERTY" (confirm)="duplicateProperty()" confirmButtonText="OK" [isWarning]="true">
    <div>
        You are duplicating this property.  To change the information, click on edit after duplication is complete.        
    </div>    
    <div style="font-weight: bold; font-size: larger;">
        This may take several moments to complete!
    </div>    
</sp-modal>
